<kendo-dialog
        *ngIf="opened"
        [title]="title">
    <p class="item">
        Item: {{inventoryItem.description}}
    </p>
    <div class="partDialogOutside">
        <div>
            <label>Quantity</label>
            <input (change)="onChanged($event)" [(ngModel)]="wholeUnit" class="formulaBox"  kendoTextBox/>
        </div>
        <p style="padding: 10px"> + </p>
        <div>
            <label>Partial Pack Size</label>
            <input (change)="onChanged($event)" [(ngModel)]="partialUnit" class="formulaBox" kendoTextBox/>
        </div>
        <p style="padding: 10px"> = </p>
        <div>
            <label>Adjusted Quantity</label>
            <input [value]="this.decimalValue" class="formulaBox" disabled="disabled" kendoTextBox/>
        </div>
    </div>
    <kendo-dialog-actions>
        <button (click)="close($event)" kendoButton>Cancel</button>
        <button (click)="close($event)" kendoButton primary="true">Save</button>
    </kendo-dialog-actions>
</kendo-dialog>
<div kendoDialogContainer></div>


